import PropTypes from "prop-types";
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import { MSpinner } from "components/Shared";

class SummaryCardValuation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverClass: Array(9).fill("")
    };
    this.handleTableHover = this.handleTableHover.bind(this);
    this.handleTableBlur = this.handleTableBlur.bind(this);
    this.handleTableClick = this.handleTableClick.bind(this);
    this.tableElem = null;
  }  
  componentDidUpdate(prevProps) {
    if ((this.props.payPeriodId !== prevProps.payPeriodId) || (this.props.internetUserId !== prevProps.internetUserId)) {
      this.props.getData(this.props.internetUserId, this.props.payPeriodId);
      this.props.filterDateCallBack(undefined);
    }
    if (!prevProps.refreshCard && this.props.refreshCard) {
      this.props.getData(this.props.internetUserId, this.props.payPeriodId);
    }
  }
  UNSAFE_componentWillMount() {
    this.props.getData(this.props.internetUserId, this.props.payPeriodId);
  }
  handleTableHover(event) {
    let newCol = Array(9).fill("");
    newCol[event.target.abbr] = "hover";
    this.setState({ hoverClass: newCol });
  }
  handleTableBlur() {
    this.setState({ hoverClass: Array(9).fill("") });
  }
  handleTableClick(event) {
    let day = event.target.abbr;
    let filterDate =
      Number(day) > 7
        ? undefined
        : this.props.data.productionDailyHours.timeByDayList.find(
          x => x.dayOfWeek === Number(day)
        ).date;
    this.props.filterDateCallBack(filterDate);
  }
  render() {
    if (this.props.isFetchingData) {
      return <MSpinner />;
    }
    // matrix = { production: [dayOfWeek: TimeMinutes, ...], nonProduction: [dayOfWeek: TimeMinutes, ...], total: [dayOfWeek: TimeMinutes, ...]}
    let hoursByDayMatrix = {
      production: _.range(0, 7).map(
        i =>
          Number(this.props.data.productionDailyHours.timeByDayList.find(
            x => x.dayOfWeek === i
          ).hours).toFixed(2)
      ),
      nonProduction: _.range(0, 7).map(
        i =>
          Number(this.props.data.nonProductionDailyHours.timeByDayList.find(
            x => x.dayOfWeek === i
          ).hours).toFixed(2)
      ),
      costEfficiency: _.range(0, 7).map(
        i =>
          Number(this.props.data.dailyCostEfficiency.amountByDayList.find(
            x => x.dayOfWeek === i
          ).amount).toFixed(2)
      ),
      calendarHours: _.range(0, 7).map(
        i =>
          Number(this.props.data.calendarDailyHours.timeByDayList.find(
            x => x.dayOfWeek === i
          ).hours).toFixed(2)
      ),
      total: []
    };

    hoursByDayMatrix.total = _.range(0, 7).map(
      i => Number(+hoursByDayMatrix.production[i] + +hoursByDayMatrix.nonProduction[i]).toFixed(2)
    );
    const { isAppraiserEmployeeTimeLogs } = this.props;

    return (
      <Card className={`card-unnested${isAppraiserEmployeeTimeLogs ? "" : " profile-card"}`}>
        <CardContent>
          <Typography variant="h6">Summary</Typography>
        </CardContent>
        <div className={`${isAppraiserEmployeeTimeLogs ? "qa-table-employee-timelogs" : "qa-table"}`}>
          <table
            ref={elem => {
              if (elem) {
                this.tableElem = elem;
                this.tableElem.addEventListener(
                  "mouseover",
                  this.handleTableHover
                );
                this.tableElem.addEventListener(
                  "mouseout",
                  this.handleTableBlur
                );
                this.tableElem.addEventListener("click", this.handleTableClick);
              }
            }}
          >
            <thead>
              <tr>
                <th className="qa-row" style={{ width: 180 }}>{this.props.employeeName}</th>
                <th className="qa-col">Mon</th>
                <th className="qa-col">Tue</th>
                <th className="qa-col">Wed</th>
                <th className="qa-col">Thu</th>
                <th className="qa-col">Fri</th>
                <th className="qa-col">Sat</th>
                <th className="qa-col">Sun</th>
                <th className="qa-col">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className="qa-row">Production Hours</th>
                {hoursByDayMatrix.production.map(
                  (x, i) =>
                    i > 0 && (
                      <td key={i} className={this.state.hoverClass[i]} abbr={i}>
                        {x}
                      </td>
                    )
                )}
                <td
                  className={`border-right ${this.state.hoverClass[0]}`}
                  abbr={0}
                >
                  {hoursByDayMatrix.production[0]}
                </td>
                <td className={this.state.hoverClass[8]} abbr={8}>
                  {Number(this.props.data.productionHoursTotal).toFixed(2)}
                </td>
              </tr>
              <tr>
                <th className="qa-row">Calendar Hours</th>
                {hoursByDayMatrix.calendarHours.map(
                  (x, i) =>
                    i > 0 && (
                      <td key={i} className={this.state.hoverClass[i]} abbr={i}>
                        {x}
                      </td>
                    )
                )}
                <td
                  className={`border-right ${this.state.hoverClass[0]}`}
                  abbr={0}
                >
                  {hoursByDayMatrix.calendarHours[0]}
                </td>
                <td className={this.state.hoverClass[8]} abbr={8}>
                  {Number(this.props.data.calendarHoursTotal).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    );
  }
}

SummaryCardValuation.defaultProps = {
  isEmployeeTimeLogsView: false,
  isAppraiserEmployeeTimeLogs: false,
};

SummaryCardValuation.propTypes = {
  data: PropTypes.object.isRequired,
  filterDateCallBack: PropTypes.func.isRequired,
  isFetchingData: PropTypes.bool.isRequired,
  getData: PropTypes.func.isRequired,
  payPeriodId: PropTypes.number.isRequired,
  internetUserId: PropTypes.number.isRequired,
  employeeName: PropTypes.string,
  refreshCard: PropTypes.bool,
  magicMinHeight: PropTypes.bool,
  isEmployeeTimeLogsView: PropTypes.bool,
  isAppraiserEmployeeTimeLogs: PropTypes.bool,
};
export default SummaryCardValuation;